// src/utils/axiosConfig.js
import axios from 'axios';

// ✅ Set base URL if not already set
axios.defaults.baseURL = process.env.REACT_APP_API_BASE || "https://projet-collect-v1-production.up.railway.app";

// ✅ ALWAYS send cookies (critical for session & CSRF)
axios.defaults.withCredentials = true;

// ✅ Optional: default headers
axios.defaults.headers.common['Content-Type'] = 'application/json';

axios.get('/api/ping')
  .then(res => console.log("✅ Ping successful:", res.status))
  .catch(err => console.error("❌ Ping failed:", err.response?.status));
console.log("⚡ Axios global config applied: baseURL =", axios.defaults.baseURL)
// Only add the interceptor ONCE
if (axios.interceptors.request.handlers.length === 0) {
  axios.interceptors.request.use(config => {
    let jwtToken = null;
    let csrfToken = null;

    try {
      jwtToken = localStorage.getItem('jwtToken');
      csrfToken = localStorage.getItem('csrfToken');
    } catch (err) {
      console.warn("⚠️ localStorage blocked. Using memory-only JWT/CSRF.");
    }

    // Fallback to global memory
    if (!jwtToken && window.__AUTH_JWT__) {
      jwtToken = window.__AUTH_JWT__;
    }
    if (!csrfToken && window.__CSRF_TOKEN__) {
      csrfToken = window.__CSRF_TOKEN__;
    }

    // Add headers
    if (jwtToken) {
      config.headers.Authorization = `Bearer ${jwtToken}`;
    }
    if (csrfToken) {
      config.headers['x-csrf-token'] = csrfToken;
    }

    config.withCredentials = true; // Always send cookies
    return config;
  }, error => Promise.reject(error));
}

// Set default base URL
axios.defaults.baseURL =
  import.meta?.env?.VITE_API_BASE ||
  process.env.REACT_APP_API_BASE ||
  "https://projet-collect-v1-production.up.railway.app";

export default axios;
